import React from "react";

const serverUrl = "https://macks-b.ir";
const user = JSON.parse(sessionStorage.getItem("user"));

const Header = () => {
  return {
    Accept: "application/json",
    "Content-Type": "application/json",

    cache: "no-cache",
    Authorization: `Bearer ${user && user}`,
  };
};
export const ForgetPass = (request) => {
  return fetch(serverUrl + "/api/User/forgetpassword", {
    method: "POST",
    headers: Header(),
    body: JSON.stringify(request),
  });
};
export const RecoverPass = (request) => {
  return fetch(serverUrl + "/api/User/set-new-password", {
    method: "PUT",
    headers: Header(),
    body: JSON.stringify(request),
  });
};
export const Login = (request) => {
  return fetch(serverUrl + "/api/User/Login", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      apiKey: localStorage.getItem("apiKey"),
      cache: "no-cache",
    },
    body: JSON.stringify(request),
  });
};

export const ConfirmFeedback = (request) => {
  return fetch(serverUrl + "/api/FeedBack/IsSeen", {
    method: "POST",
    headers: Header(),
    body: JSON.stringify(request),
  });
};

export const ConfirmOrder = (request) => {
  return fetch(serverUrl + "/api/Order/IsDone", {
    method: "POST",
    headers: Header(),
    body: JSON.stringify(request),
  });
};
export const CancelOrder = (id) => {
  return fetch(serverUrl + `/api/Order/cancel-order/${id}`, {
    method: "POST",
    headers: Header(),
  });
};

export const DiscountconfirmGet = (data) => {
  return fetch(serverUrl + `/api/DiscountCode/Activate`, {
    method: "PUT",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const UserconfirmGet = (data) => {
  return fetch(serverUrl + `/api/User/Activate`, {
    method: "PUT",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const ParentcatGet = () => {
  return fetch(serverUrl + `/api/CategoryPost_Category/GetByParent/`, {
    method: "GET",
    headers: Header(),
  });
};
export const GetParentcatGet = () => {
  return fetch(serverUrl + `/api/CategoryPost_Category/GetCategoryList`, {
    method: "GET",
    headers: Header(),
  });
};
export const BrandGet = (skip, take) => {
  return fetch(serverUrl + `/api/Brand/${skip}/${take}`, {
    method: "GET",
    headers: Header(),
  });
};
//////////////////report

export const ReportdGet = (start, end) => {
  return fetch(
    serverUrl + `/api/Order/GetHistorySale?start=${start}&end=${end}`,
    {
      method: "GET",
      headers: Header(),
    }
  );
};

//////////////////report
export const AdsGet = (skip, take) => {
  return fetch(serverUrl + `/api/Advertisement/${skip}/${take}`, {
    method: "GET",
    headers: Header(),
  });
};
export const AdsGetAll = (skip, take) => {
  return fetch(
    serverUrl + `/api/Advertisement/getall/true/true/${skip}/${take}`,
    {
      method: "GET",
      headers: Header(),
    }
  );
};
export const Adsconfirm = (data) => {
  return fetch(serverUrl + "/api/Advertisement/isconfirm", {
    method: "PUT",
    headers: Header(),
    body: JSON.stringify(data),
  });
};
export const SearchAds = (skip, take, data) => {
  return fetch(
    serverUrl +
    `/api/Advertisement/search-advertisement?skip=${skip}&take=${take}`,
    {
      method: "POST",
      headers: Header(),
      body: JSON.stringify(data),
    }
  );
};
export const SearchAdsprovince = (skip, take, data) => {
  return fetch(
    serverUrl +
    `/api/Advertisement/search-advertisement-province?skip=${skip}&take=${take}`,
    {
      method: "POST",
      headers: Header(),
      body: JSON.stringify(data),
    }
  );
};
export const SearchAdsByProvinceId = (skip, take, data) => {
  return fetch(
    serverUrl +
    `/api/Advertisement/search-advertisement-province?skip=${skip}&take=${take}`,
    {
      method: "POST",
      headers: Header(),
      body: JSON.stringify(data),
    }
  );
};
export const SearchConfirmAds = (isConfirm, isNotConfirm, skip, take) => {
  return fetch(
    serverUrl +
    `/api/Advertisement/getall/${isConfirm}/${isNotConfirm}/${skip}/${take}`,
    {
      method: "GET",
      headers: Header(),
    }
  );
};

//////////////////orderproduct
export const orderproductCreate = (data, id) => {
  return fetch(serverUrl + `/api/Order/AddProductToOrder/${id}`, {
    method: "POST",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const orderproductUpdate = (data, id) => {
  return fetch(serverUrl + `/api/Order/PutProductInOrder/${id}`, {
    method: "PUT",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

// export const orderproductDelete = (orderid, productid) => {
//   return fetch(
//     serverUrl + `/api/Order/DeleteProductFromOrder/${orderid}/${productid}`,
//     {
//       method: "DELETE",
//       headers: Header(),
//     }
//   );
// };
export const orderproductDelete = (id, proid) => {
  return fetch(
    serverUrl + "/api/Order/DeleteProductFromOrder/" + id + "/" + proid,
    {
      method: "DELETE",
      headers: Header(),
    }
  );
};

//////////////////orderproduct

//////////////////category

export const CategoryGet = (skip, take) => {
  return fetch(serverUrl + `/api/AdsCategory/${skip}/${take}`, {
    method: "GET",
    headers: Header(),
  });
};
export const CategoryPostGet = () => {
  return fetch(serverUrl + `/api/CategoryPost_Category/GetPostCategoryList`, {
    method: "GET",
    headers: Header(),
  });
};

export const CatgoryUploadFile = (data) => {
  const formData = new FormData();
  formData.append("file", data);

  return fetch(serverUrl + "/api/File/upload", {
    method: "POST",
    headers: {
      token: localStorage.getItem("apiKey"),
    },
    body: formData,
  });
};

export const CategoryCreate = (data) => {
  return fetch(serverUrl + "/api/AdsCategory", {
    method: "POST",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const CategoryUpdate = (data) => {
  return fetch(serverUrl + "/api/AdsCategory", {
    method: "PUT",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const CategoryGetById = (id) => {
  return fetch(serverUrl + `/api/AdsCategory/${id}`, {
    method: "GET",
    headers: Header(),
  });
};

export const CategoryDelete = (id) => {
  return fetch(serverUrl + "/api/AdsCategory/" + id, {
    method: "DELETE",
    headers: Header(),
  });
};
export const AdsDelete = (id) => {
  return fetch(serverUrl + "/api/Advertisement/" + id, {
    method: "DELETE",
    headers: Header(),
  });
};

// //**********************************************************/   industrial

export const TownsGetAll = () => {
  return fetch(serverUrl + `/api/Towns/GetAll`, {
    method: "GET",
    headers: Header(),
  });
};
export const TownsGet = (skip, take) => {
  return fetch(serverUrl + `/api/Towns/${skip}/${take}`, {
    method: "GET",
    headers: Header(),
  });
};
export const getAdvertismentByTownId = (id, skip, take) => {
  return fetch(
    serverUrl + `/api/Advertisement/getbytown/${id}/true/true/${skip}/${take}`,
    {
      method: "GET",
      headers: Header(),
    }
  );
};
export const getAdvertismentByTownId2 = (id, isconf, isnotconf, skip, take) => {
  return fetch(
    serverUrl +
    `/api/Advertisement/getbytown/${id}/${isconf}/${isnotconf}/${skip}/${take}`,
    {
      method: "GET",
      headers: Header(),
    }
  );
};

export const TownsUploadFile = (data) => {
  const formData = new FormData();
  formData.append("file", data);

  return fetch(serverUrl + "/api/File/upload", {
    method: "POST",
    headers: {
      token: localStorage.getItem("apiKey"),
    },
    body: formData,
  });
};
export const IndustrialUnitGetByTown = (id) => {
  return fetch(
    serverUrl + `/api/IndustrialUnit/GetIndustrialUnitByTown/${id}`,
    {
      method: "GET",
      // headers: Header(),
    }
  );
};
export const TownsCreate = (data) => {
  return fetch(serverUrl + "/api/Towns", {
    method: "POST",
    headers: Header(),
    body: JSON.stringify(data),
  });
};
export const TownsCreateCompelet = (data) => {
  return fetch(serverUrl + "/api/Towns/PostTownsComplete", {
    method: "POST",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const ActiveTown = (data) => {
  return fetch(serverUrl + "/api/Towns/PutActiveTown", {
    method: "PUT",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const ChangeChangeTownManager = (data) => {
  return fetch(serverUrl + "/api/Towns/ChangeTownManager", {
    method: "PUT",
    headers: Header(),
    body: JSON.stringify(data),
  });
};


export const ChangeIndustrialManager = (data) => {
  return fetch(serverUrl + "/api/IndustrialUnit/ChangeIndustrialManager", {
    method: "PUT",
    headers: Header(),
    body: JSON.stringify(data),
  });
};


export const SearchByPhoneNumber = (PhoenNumber) => {
  return fetch(
    serverUrl + `/api/User/search-user-by-mobile/${PhoenNumber}`,
    {
      method: "GET",
      // headers: Header(),
    }
  );
};

export const TownsUpdate = (data) => {
  return fetch(serverUrl + "/api/Towns", {
    method: "PUT",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const TownsDelete = (id) => {
  return fetch(serverUrl + `/api/Towns/${id}`, {
    method: "DELETE",
    headers: Header(),
  });
};

export const DELETE_BY_ID_IN_All_USer = (id) => {
  return fetch(serverUrl + `/api/User/${id}`, {
    method: "DELETE",
    headers: Header(),
  });
};

export const TownsGetById = (id) => {
  return fetch(serverUrl + `/api/Towns/GetTownsById/${id}`, {
    method: "GET",
    headers: Header(),
  });
};
export const TownsGetByProvinceId = (id) => {
  return fetch(serverUrl + `/api/Towns/GetTownsByProvince/${id}`, {
    method: "GET",
    headers: Header(),
  });
};

export const GetAllUserList = (skip, take) => {
  return fetch(serverUrl + `/api/User/${skip}/${take}/`, {
    method: "GET",
    headers: Header(),
  });
};

//**********************************************************/   industrial
// //**********************************************************/  News
export const UserGetByMobile = (tell) => {
  return fetch(serverUrl + `/api/User/get-user-by-mobile/${tell}`, {
    method: "GET",
    headers: Header(),
  });
};
export const NewsGet = (skip, take) => {
  return fetch(serverUrl + `/api/News/GetProvinceNews/${skip}/${take}`, {
    method: "GET",
    headers: Header(),
  });
};

export const NewsUploadFile = (data) => {
  const formData = new FormData();
  formData.append("file", data);

  return fetch(serverUrl + "/api/File/upload", {
    method: "POST",
    headers: {
      token: localStorage.getItem("apiKey"),
    },
    body: formData,
  });
};

export const NewsCreate = (data) => {
  return fetch(serverUrl + "/api/News/PostNewsProvince", {
    method: "POST",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const SearchAllUser = (SearchText) => {
  return fetch(serverUrl + `/api/User/GetUsers/0/10/${SearchText}`, {
    method: "GET",
    headers: Header(),
    // body: JSON.stringify(data),
  });
};

export const NewsUpdate = (data) => {
  return fetch(serverUrl + "/api/News", {
    method: "PUT",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const EditUserByIDALL = (data) => {
  return fetch(serverUrl + "/api/User/UpdateUserV2", {
    method: "PUT",
    headers: Header(),
    body: JSON.stringify(data),
  });
};


export const ADDUserByIDALL = (data) => {
  return fetch(serverUrl + "/api/User/PostNewUserV2", {
    method: "POST",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const NewsGetById = (id) => {
  return fetch(serverUrl + `/api/News/${id}`, {
    method: "GET",
    headers: Header(),
  });
};

export const NewsDelete = (id) => {
  return fetch(serverUrl + `/api/News/${id}`, {
    method: "DELETE",
    headers: Header(),
  });
};

//**********************************************************/   News
//**********************************************************/   Settings

export const SettingGet = (skip, take) => {
  return fetch(serverUrl + `/api/Setting/${skip}/${take}`, {
    method: "GET",
    headers: Header(),
  });
};

export const UploadFile = (data) => {
  const formData = new FormData();
  formData.append("file", data, data.name);

  return fetch(serverUrl + "/api/File/upload", {
    method: "POST",
    headers: {
      token: localStorage.getItem("apiKey"),
    },
    body: formData,
  });
};

export const SettingUploadFile = (data) => {
  const formData = new FormData();
  formData.append("file", data);

  return fetch(serverUrl + "/api/File/upload", {
    method: "POST",
    headers: Header(),
    // headers: {
    //   token: localStorage.getItem("apiKey"),
    // },
    body: formData,
  });
};

export const SettingCreate = (data) => {
  return fetch(serverUrl + "/api/Setting", {
    method: "POST",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const SettingUpdate = (data) => {
  return fetch(serverUrl + "/api/Setting", {
    method: "PUT",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const SettingGetById = (id) => {
  return fetch(serverUrl + `/api/Setting/${id}`, {
    method: "GET",
    headers: Header(),
  });
};

export const SettingDelete = (id) => {
  return fetch(serverUrl + `/api/Setting/${id}`, {
    method: "DELETE",
    headers: Header(),
  });
};

//**********************************************************/   Setting
//**********************************************************/   province
export const ProvincegGet = (skip, take) => {
  return fetch(serverUrl + `/api/Province/${skip}/${take}`, {
    method: "GET",
    headers: Header(),
  });
};
export const ProvincegGetAll = () => {
  return fetch(serverUrl + `/api/Province/GetAllList`, {
    method: "GET",
    headers: Header(),
  });
};

export const ProvinceCreate = (data) => {
  return fetch(serverUrl + "/api/Province", {
    method: "POST",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const ProvinceUpdate = (data) => {
  return fetch(serverUrl + "/api/Province", {
    method: "PUT",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const provinceGetById = (id) => {
  return fetch(serverUrl + `/api/Province/${id}`, {
    method: "GET",
    headers: Header(),
  });
};

export const ProvinceDelete = (id) => {
  return fetch(serverUrl + `/api/Province/${id}`, {
    method: "DELETE",
    headers: Header(),
  });
};

//**********************************************************/   province
//**********************************************************/   city
export const CityGet = (skip, take) => {
  return fetch(serverUrl + `/api/City/${skip}/${take}`, {
    method: "GET",
    headers: Header(),
  });
};

export const CityCreate = (data) => {
  return fetch(serverUrl + "/api/City", {
    method: "POST",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const CityUpdate = (data) => {
  return fetch(serverUrl + "/api/City", {
    method: "PUT",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const CityGetById = (id) => {
  return fetch(serverUrl + `/api/City/${id}`, {
    method: "GET",
    headers: Header(),
  });
};

export const CityDelete = (id) => {
  return fetch(serverUrl + `/api/City/${id}`, {
    method: "DELETE",
    headers: Header(),
  });
};

export const GetCityByProvinceId = (id) => {
  return fetch(serverUrl + `/api/City/get-city-by-provinceid/${id}/0/999`, {
    method: "GET",
    headers: Header(),
  });
};

//**********************************************************/   city
//**********************************************************/   Role
export const RoleGet = (skip, take) => {
  return fetch(serverUrl + `/api/Role/${skip}/${take}`, {
    method: "GET",
    headers: Header(),
  });
};

export const RoleCreate = (data) => {
  return fetch(serverUrl + "/api/Role", {
    method: "POST",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const RoleUpdate = (data) => {
  return fetch(serverUrl + "/api/Role", {
    method: "PUT",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const RoleGetById = (id) => {
  return fetch(serverUrl + `/api/Role/${id}`, {
    method: "GET",
    headers: Header(),
  });
};

export const RoleDelete = (id) => {
  return fetch(serverUrl + `/api/Role/${id}`, {
    method: "DELETE",
    headers: Header(),
  });
};

//**********************************************************/   Role
//**********************************************************/   Feedback
export const FeedbackGetById = (id) => {
  return fetch(serverUrl + `/api/FeedBack/${id}`, {
    method: "GET",
    headers: Header(),
  });
};

export const FeedbackGet = (size, count) => {
  return fetch(serverUrl + `/api/FeedBack/${size}/${count}`, {
    method: "GET",
    headers: Header(),
  });
};

// export const FeedbackDelete = (id) => {
//   return fetch(serverUrl + `/api/35/Feedbacks/${id}`, {
//     method: "DELETE",
//     headers: Header(),
//   });
// };

// //**********************************************************/   Feedback
// //**********************************************************/   Discount

export const DiscountCodeGet = () => {
  return fetch(serverUrl + `/api/DiscountCode`, {
    method: "GET",
    headers: Header(),
  });
};

export const DiscountCodeCreate = (data) => {
  return fetch(serverUrl + "/api/DiscountCode", {
    method: "POST",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const DiscountCodeUpdate = (data) => {
  return fetch(serverUrl + "/api/DiscountCode", {
    method: "PUT",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const DiscountCodeGetById = (id) => {
  return fetch(serverUrl + `/api/DiscountCode/${id}`, {
    method: "GET",
    headers: Header(),
  });
};

export const DiscountCodeDelete = (id) => {
  return fetch(serverUrl + `/api/DiscountCode/${id}`, {
    method: "DELETE",
    headers: Header(),
  });
};

// //**********************************************************/   Discount
// //**********************************************************/   brands

// export const BrandGet = () => {
//   return fetch(serverUrl + `/api/Brand`, {
//     method: "GET",
//     headers: Header(),
//   });
// };

export const BrandCreate = (data) => {
  return fetch(serverUrl + "/api/Brand", {
    method: "POST",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const BrandUpdate = (data) => {
  return fetch(serverUrl + `/api/Brand`, {
    method: "PUT",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const BrandGetById = (id) => {
  return fetch(serverUrl + `/api/Brand/${id}`, {
    method: "GET",
    headers: Header(),
  });
};

export const BrandDelete = (id) => {
  return fetch(serverUrl + `/api/Brand/${id}`, {
    method: "DELETE",
    headers: Header(),
  });
};
// //**********************************************************/   brands
// //**********************************************************/   Units
export const UnitGet = (skip, take) => {
  return fetch(serverUrl + `/api/ProductUnit/${skip}/${take}`, {
    method: "GET",
    headers: Header(),
  });
};

export const UnitCreate = (data) => {
  return fetch(serverUrl + "/api/ProductUnit", {
    method: "POST",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const UnitUpdate = (data) => {
  return fetch(serverUrl + `/api/ProductUnit`, {
    method: "PUT",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const UnitGetById = (id) => {
  return fetch(serverUrl + `/api/ProductUnit/${id}`, {
    method: "GET",
    headers: Header(),
  });
};

export const UnitDelete = (id) => {
  return fetch(serverUrl + `/api/ProductUnit/${id}`, {
    method: "DELETE",
    headers: Header(),
  });
};
// //**********************************************************/   Units
// //**********************************************************/   Order

export const OrderGetById = (id) => {
  return fetch(serverUrl + `/api/Order/GetProducts/${id}`, {
    method: "GET",
    headers: Header(),
  });
};

export const OrderGet = (size, count) => {
  return fetch(serverUrl + `/api/Order/GetListOrder/false/${size}/${count}`, {
    method: "GET",
    headers: Header(),
  });
};

// //**********************************************************/   Order
// //**********************************************************/   User

export const UserGet = (size, count) => {
  return fetch(serverUrl + `/api/User/${size}/${count}`, {
    method: "GET",
    headers: Header(),
  });
};

export const UserUpdate = (data) => {
  return fetch(serverUrl + "/api/User", {
    method: "PUT",
    headers: Header(),
    body: JSON.stringify(data),
  });
};
export const UserCreate = (data) => {
  return fetch(serverUrl + "/api/User", {
    method: "Post",
    headers: Header(),
    body: JSON.stringify(data),
  });
};
export const USerGetById = (id) => {
  return fetch(serverUrl + `/api/User/${id}`, {
    method: "GET",
    headers: Header(),
  });
};

export const UserDelete = (id) => {
  return fetch(serverUrl + `/api/User/${id}`, {
    method: "DELETE",
    headers: Header(),
  });
};
/////////// product
export const ProductGet = (skip, take) => {
  return fetch(serverUrl + `/api/Product/${skip}/${take}`, {
    method: "GET",
    headers: Header(),
  });
};

export const ProductUploadFile = (data) => {
  const formData = new FormData();
  formData.append("file", data);

  return fetch(serverUrl + "/api/File/upload", {
    method: "POST",
    headers: {
      token: localStorage.getItem("apiKey"),
    },
    body: formData,
  });
};

export const ProductCreate = (data) => {
  return fetch(serverUrl + "/api/Product", {
    method: "POST",
    headers: Header(),
    body: JSON.stringify(data),
  });
};
export const ProductSearch = (skip, take, data) => {
  return fetch(serverUrl + `/api/Product/GetListFilter/${skip}/${take}`, {
    method: "POST",
    headers: Header(),
    body: JSON.stringify(data),
  });
};
export const OrderSearch = (skip, take, name) => {
  return fetch(serverUrl + `/api/Order/Search/${name}/${skip}/${take}`, {
    method: "GET",
    headers: Header(),
  });
};

export const ProductUpdate = (data) => {
  return fetch(serverUrl + "/api/Product", {
    method: "PUT",
    headers: Header(),
    body: JSON.stringify(data),
  });
};

export const ProductGetById = (id) => {
  return fetch(serverUrl + `/api/Product/${id}`, {
    method: "GET",
    headers: Header(),
  });
};

export const ProductDelete = (id) => {
  return fetch(serverUrl + "/api/Product/" + id, {
    method: "DELETE",
    headers: Header(),
  });
};
//**********************************************************/   Setting

// export const SettingGet = (skip, take) => {
//   return fetch(serverUrl + `api/Setting/${skip}/${take}`, {
//     method: "GET",
//     headers: Header(),
//   });
// };

// export const SettingCreate = (data) => {
//   return fetch(serverUrl + "api/Setting", {
//     method: "POST",
//     headers: Header(),
//     body: JSON.stringify(data),
//   });
// };

// export const SettingUpdate = (data) => {
//   return fetch(serverUrl + "api/Setting", {
//     method: "PUT",
//     headers: Header(),
//     body: JSON.stringify(data),
//   });
// };

// export const SettingGetById = (id) => {
//   return fetch(serverUrl + `api/Setting/${id}`, {
//     method: "GET",
//     headers: Header(),
//   });
// };

// export const SettingDelete = (id) => {
//   return fetch(serverUrl + `api/Setting/${id}`, {
//     method: "DELETE",
//     headers: Header(),
//   });
// };

//**********************************************************/   Setting
